import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Page404.module.css';

export const Page404 = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h1 className={styles.title}>404</h1>
        <p className={styles.message}>Страница не найдена</p>
        <Link to="/" className={styles.link}>
          Вернуться на главную
        </Link>
      </div>
    </div>
  );
};
